import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../../context/auth";
import { ICondPagOption } from "../types/proposta";

export function usePropostaPagamentos() {
  const { api } = useAuth();
  const [condPagOptions, setCondPagOptions] = useState<ICondPagOption[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchCondPag = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get("/sin/condpag");
      const data = res.data?.data ?? res.data ?? [];
      setCondPagOptions(
        Array.isArray(data)
          ? data.map((item: { id: number; description: string }) => ({
              id: item.id,
              description: item.description,
            }))
          : [],
      );
    } catch (error) {
      console.error("Erro ao buscar condições de pagamento:", error);
    } finally {
      setLoading(false);
    }
  }, [api]);

  useEffect(() => {
    fetchCondPag();
  }, [fetchCondPag]);

  return { condPagOptions, loading, refetch: fetchCondPag };
}
